<div class="page-wrap">
  <div class="path-wrap">
    <svg
      class="main-svg"
      width="685"
      height="356"
      viewBox="0 0 546 356"
      xmlns="http://www.w3.org/2000/svg"
    >
      <svg
        x="0"
        y="0"
        width="546"
        height="356"
        viewBox="0 0 546 356"
        xmlns="http://www.w3.org/2000/svg"
      >
        <defs>
          <linearGradient x1="0%" y1="50%" x2="100%" y2="50%" id="xgkh9jj7ua">
            <stop stop-color="#F6F6F9" offset="0%" />
            <stop stop-color="#E8E8E9" offset="100%" />
          </linearGradient>
        </defs>
        <path
          d="M185.544 5.57C123.53 27.367 150.3 56.953 114.07 92.991c-36.505 36.313-92.104 9.252-110.987 86.904-22.168 91.159 80.65 84.134 134.444 109.672 42.531 20.19 81.913 61.316 148.045 66.013 66.16 4.681 106.438-30.575 117.258-67.149 10.845-36.574 25.473-70.094 85.548-99.023 60.075-28.929 74.508-67.133 35.678-123.74-56.01-81.654-137.34-38.399-183.018-36.879-23.736.791-44.21-6.787-64.383-14.366C257.46 7.212 238.536 0 217.333 0c-10 0-20.507 1.604-31.789 5.57"
          fill="url(#xgkh9jj7ua)"
          fill-rule="evenodd"
        />
      </svg>

      <svg
        x="20"
        y="20"
        width="645"
        height="312"
        viewBox="0 0 645 312"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g fill="#2EA3F2" fill-rule="evenodd">
          <path
            d="M193.405 16.3c0 8.396-6.806 15.2-15.201 15.2-8.394 0-15.2-6.804-15.2-15.2 0-8.395 6.806-15.2 15.2-15.2 8.395 0 15.2 6.805 15.2 15.2M33.784 213.06c-4.394 0-7.97 3.575-7.97 7.97 0 4.393 3.576 7.968 7.97 7.968 4.395 0 7.97-3.575 7.97-7.967 0-4.396-3.575-7.97-7.97-7.97m0 17.627c-5.326 0-9.66-4.332-9.66-9.657 0-5.327 4.334-9.66 9.66-9.66 5.327 0 9.66 4.333 9.66 9.66 0 5.325-4.333 9.657-9.66 9.657M79.574 1.945a3.568 3.568 0 0 0-3.563 3.563 3.567 3.567 0 0 0 3.563 3.562 3.567 3.567 0 0 0 3.563-3.562 3.568 3.568 0 0 0-3.563-3.563m0 8.814a5.257 5.257 0 0 1-5.252-5.25A5.256 5.256 0 0 1 79.574.256a5.256 5.256 0 0 1 5.251 5.251 5.256 5.256 0 0 1-5.251 5.251M5.411 290.589a.845.845 0 0 1-.845-.845v-8.025a.845.845 0 1 1 1.69 0v8.025a.844.844 0 0 1-.845.845"
          />
          <path
            d="M9.424 286.576H1.4a.845.845 0 1 1 0-1.689h8.025a.844.844 0 1 1 0 1.69M310.633 79.786a.845.845 0 0 1-.845-.845v-8.025a.845.845 0 1 1 1.689 0v8.025a.844.844 0 0 1-.844.845"
          />
          <path
            d="M314.645 75.773h-8.026a.844.844 0 1 1 0-1.689h8.026a.844.844 0 1 1 0 1.689M180.48 254.65a4.57 4.57 0 1 1 0-9.14 4.57 4.57 0 0 1 0 9.14M229.276 301.28a4.45 4.45 0 0 0-4.445 4.444 4.45 4.45 0 0 0 4.445 4.444 4.45 4.45 0 0 0 4.443-4.444 4.45 4.45 0 0 0-4.443-4.444m0 10.577a6.14 6.14 0 0 1-6.134-6.133 6.14 6.14 0 0 1 6.134-6.133 6.14 6.14 0 0 1 6.132 6.133 6.14 6.14 0 0 1-6.132 6.133M587.478 64.936a4.796 4.796 0 1 0-9.592.001 4.796 4.796 0 0 0 9.592 0m-1.18 0a3.62 3.62 0 0 1-3.616 3.617 3.621 3.621 0 0 1-3.617-3.618 3.62 3.62 0 0 1 3.617-3.616 3.62 3.62 0 0 1 3.616 3.616M640.176 197.63a4.797 4.797 0 1 1 0-9.593 4.797 4.797 0 0 1 0 9.594M572.823 135.76h-4.792a.885.885 0 1 1 0-1.771h4.792a.885.885 0 1 1 0 1.772M583.147 135.76h-4.792a.886.886 0 1 1 0-1.771h4.792a.885.885 0 1 1 0 1.772M575.59 143.318a.885.885 0 0 1-.887-.886v-4.792a.885.885 0 1 1 1.772 0v4.792c0 .49-.396.886-.886.886M575.59 132.994a.885.885 0 0 1-.887-.886v-4.792a.885.885 0 1 1 1.772 0v4.792c0 .49-.396.886-.886.886M344.496 241.628a4.797 4.797 0 1 0-9.593 0 4.797 4.797 0 0 0 9.593 0m-1.18 0a3.62 3.62 0 0 1-3.617 3.616 3.62 3.62 0 0 1-3.616-3.616 3.62 3.62 0 0 1 3.616-3.616 3.62 3.62 0 0 1 3.617 3.616M344.496 258.561a4.797 4.797 0 1 0-9.593 0 4.797 4.797 0 0 0 9.593 0m-1.18 0a3.62 3.62 0 0 1-3.617 3.617 3.62 3.62 0 0 1-3.616-3.617 3.62 3.62 0 0 1 3.616-3.615 3.62 3.62 0 0 1 3.617 3.615M339.7 280.291a4.796 4.796 0 1 1 0-9.593 4.796 4.796 0 0 1 0 9.593M279.58 205.49a4.797 4.797 0 1 0-9.593.001 4.797 4.797 0 0 0 9.593 0m-1.18 0a3.621 3.621 0 0 1-3.617 3.616 3.62 3.62 0 0 1-3.616-3.617 3.62 3.62 0 0 1 3.616-3.616 3.62 3.62 0 0 1 3.617 3.616M310.62 157.433h-4.79a.885.885 0 1 1 0-1.772h4.79a.885.885 0 1 1 0 1.772M320.943 157.433h-4.79a.885.885 0 1 1 0-1.772h4.79a.885.885 0 1 1 0 1.772M313.386 164.991a.885.885 0 0 1-.886-.887v-4.79a.885.885 0 1 1 1.772 0v4.79a.885.885 0 0 1-.886.887M313.386 154.667a.885.885 0 0 1-.886-.887v-4.791a.885.885 0 1 1 1.772 0v4.791a.885.885 0 0 1-.886.887M468.467 296.503c-3.751 0-6.803 3.053-6.803 6.804a6.81 6.81 0 0 0 6.803 6.802c3.752 0 6.804-3.052 6.804-6.802a6.812 6.812 0 0 0-6.804-6.804m0 15.048c-4.546 0-8.245-3.698-8.245-8.244 0-4.547 3.699-8.245 8.245-8.245 4.547 0 8.246 3.698 8.246 8.245 0 4.546-3.699 8.244-8.246 8.244M525.057 276.54a.886.886 0 1 1 0-1.773h4.792a.885.885 0 1 1 0 1.772h-4.792zM540.173 276.54h-4.792a.885.885 0 1 1 0-1.773h4.792a.885.885 0 1 1 0 1.772M532.616 273.773a.885.885 0 0 1-.886-.887v-4.79a.885.885 0 1 1 1.772 0v4.79a.885.885 0 0 1-.886.887M405.895 50.315a3.901 3.901 0 1 1 0-7.802 3.901 3.901 0 0 1 0 7.802M447.547 90.12a3.798 3.798 0 0 0-3.794 3.793 3.798 3.798 0 0 0 3.794 3.793 3.798 3.798 0 0 0 3.793-3.793 3.798 3.798 0 0 0-3.793-3.794m0 9.03a5.24 5.24 0 0 1-5.236-5.236 5.24 5.24 0 0 1 5.236-5.235 5.24 5.24 0 0 1 5.234 5.235 5.24 5.24 0 0 1-5.234 5.235M532.616 284.097a.885.885 0 0 1-.886-.886v-4.792a.885.885 0 1 1 1.772 0v4.792c0 .49-.396.886-.886.886"
          />
        </g>
      </svg>
      <svg
        x="60"
        y="60"
        width="250"
        height="250"
        viewBox="0 0 250 250"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g fill="none" fill-rule="evenodd">
          <path
            d="M99.823 32.454a4.57 4.57 0 1 1 0-9.14 4.57 4.57 0 0 1 0 9.14"
            fill="#A7B6BE"
          />
          <path
            d="M110.144 106.573a.844.844 0 0 1-.844-.845v-8.025a.844.844 0 1 1 1.69 0v8.025a.845.845 0 0 1-.846.845"
            fill="#FFF"
          />
          <path
            d="M114.157 102.56h-8.025a.845.845 0 1 1 0-1.689h8.025a.844.844 0 1 1 0 1.69"
            fill="#FFF"
          />
          <path
            d="M132.989 69.778c0 34.052-27.604 61.656-61.656 61.656S9.677 103.83 9.677 69.778 37.281 8.123 71.333 8.123s61.656 27.603 61.656 61.655"
            fill="#ECEFF0"
          />
          <path
            d="M172.102 159.066a3.448 3.448 0 0 1 0 4.883l-8.007 8.027c-1.366 1.357-3.547 1.357-4.888 0l-48.545-48.535a3.451 3.451 0 0 1 0-4.878l8.023-8.037a3.465 3.465 0 0 1 4.882 0l48.535 48.54z"
            fill="#2EA3F2"
          />
          <path
            d="M247.958 227.315c2.119 2.128 2.119 5.551 0 7.662l-12.565 12.595c-2.143 2.128-5.565 2.128-7.67 0L127.555 147.42c-2.112-2.113-2.112-5.558 0-7.654l12.588-12.61a5.438 5.438 0 0 1 7.662 0l100.153 100.16zM70.04 14.168c-30.758 0-55.78 25.006-55.78 55.74 0 30.752 25.021 55.77 55.78 55.77 30.744 0 55.758-25.018 55.758-55.77 0-30.734-25.014-55.74-55.759-55.74m0 125.346c-38.398 0-69.637-31.226-69.637-69.606C.402 31.517 31.642.282 70.04.282c38.386 0 69.615 31.235 69.615 69.626 0 38.38-31.229 69.606-69.615 69.606"
            fill="#3C3B3A"
          />
          <path
            fill="#2EA3F2"
            d="m159.648 138.999-20.256 20.256 4.116 4.115 20.255-20.255zM165.945 145.295l-20.256 20.257 4.116 4.115 20.255-20.256z"
          />
          <path
            d="M68.943 54.196c-5.767 5.767-15.117 5.767-20.884 0-5.767-5.768-5.767-15.117 0-20.885 5.767-5.767 15.117-5.767 20.884 0 5.768 5.768 5.768 15.117 0 20.885M90.56 41.738a5.959 5.959 0 1 1-8.426-8.427 5.959 5.959 0 0 1 8.427 8.427"
            fill="#ECEFF0"
          />
        </g>
      </svg>

      <svg
        x="400"
        y="110"
        width="191"
        height="191"
        viewBox="0 0 191 191"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g fill="none" fill-rule="evenodd" id="Ship">
          <path
            d="M98.116 167.495c-9.315 9.317-14.53 19.206-11.646 22.088 2.882 2.883 12.771-2.332 22.086-11.648 9.315-9.314 14.53-19.203 11.647-22.086-2.883-2.883-12.772 2.332-22.087 11.646"
            fill="#FDCB0F"
          />
          <path
            d="M103.508 166.537c-7.062 7.062-11.442 14.132-9.784 15.79 1.66 1.661 8.73-2.72 15.793-9.783 7.063-7.064 11.444-14.134 9.783-15.792-1.658-1.659-8.729 2.722-15.792 9.785"
            fill="#E53B2E"
          />
          <path
            fill="#2C2A2A"
            d="M90.9 98.454 108.2 163.03l26.257-7.034-17.303-64.574z"
          />
          <path
            d="m94.848 162.503 31.33-31.331c3.845-3.844 10.078-3.844 13.923 0l4.779 4.778c3.844 3.846 3.844 10.079 0 13.923l-31.331 31.33-18.701-18.7z"
            fill="#0072BC"
          />
          <path
            d="M91.19 160.705a1.695 1.695 0 0 0 0 2.4l21.758 21.756a1.696 1.696 0 1 0 2.4-2.398l-21.76-21.758a1.693 1.693 0 0 0-2.398 0"
            fill="#2C2A2A"
          />
          <path
            d="M23.269 92.648c-9.315 9.317-19.204 14.53-22.087 11.648-2.883-2.882 2.33-12.77 11.647-22.086 9.315-9.318 19.204-14.53 22.086-11.649 2.884 2.883-2.331 12.772-11.646 22.087"
            fill="#FDCB0F"
          />
          <path
            d="M24.23 87.257C17.165 94.319 10.094 98.7 8.436 97.042c-1.659-1.66 2.722-8.73 9.785-15.793 7.062-7.062 14.132-11.443 15.791-9.785 1.66 1.658-2.72 8.73-9.784 15.793"
            fill="#E53B2E"
          />
          <path
            fill="#2C2A2A"
            d="M92.31 99.865 27.735 82.562l7.036-26.254 64.575 17.303z"
          />
          <path
            d="m28.261 95.919 31.332-31.334c3.843-3.843 3.843-10.076 0-13.92l-4.779-4.781c-3.845-3.843-10.078-3.843-13.923 0L9.56 77.218l18.701 18.7z"
            fill="#0072BC"
          />
          <path
            d="M30.06 99.576a1.698 1.698 0 0 1-2.4 0L5.904 77.818a1.695 1.695 0 0 1 0-2.4 1.695 1.695 0 0 1 2.4 0L30.06 97.176a1.698 1.698 0 0 1 0 2.4"
            fill="#2C2A2A"
          />
          <path
            d="M25.582 133.053c-11.822 11.822-18.67 24.144-15.299 27.52 3.372 3.376 15.688-3.472 27.508-15.294 11.821-11.825 18.67-24.144 15.3-27.521-3.373-3.375-15.689 3.473-27.509 15.295M45.484 152.98c-11.822 11.823-18.67 24.143-15.299 27.52 3.372 3.375 15.688-3.474 27.508-15.296 11.821-11.822 18.67-24.144 15.3-27.519-3.372-3.377-15.689 3.471-27.509 15.296"
            fill="#FDCB0F"
          />
          <path
            d="M28.541 149.638c-11.82 11.822-18.67 24.144-15.298 27.519 3.371 3.375 15.687-3.471 27.507-15.295 11.821-11.823 18.671-24.142 15.3-27.52-3.372-3.374-15.689 3.474-27.509 15.296"
            fill="#FDCB0F"
          />
          <path
            d="M32.15 133.96c-6.168 6.169-9.004 13.335-6.333 16.007 2.67 2.672 9.836-.165 16.006-6.334 6.168-6.17 9.004-13.335 6.333-16.006-2.67-2.672-9.837.164-16.006 6.334M47.917 149.727c-6.17 6.169-9.006 13.334-6.334 16.006 2.67 2.67 9.835-.165 16.005-6.335 6.168-6.168 9.004-13.334 6.335-16.006-2.672-2.67-9.838.165-16.006 6.335"
            fill="#E53B2E"
          />
          <path
            d="M36.334 145.249c-6.168 6.168-9.004 13.335-6.333 16.007 2.67 2.669 9.836-.167 16.006-6.335 6.168-6.17 9.004-13.336 6.333-16.006-2.67-2.672-9.836.165-16.006 6.334"
            fill="#E53B2E"
          />
          <path
            d="m29.766 134.735 26.265 26.263c16.94 6.038 39.11-11.359 77.783-50.03C180.072 64.711 190.56.205 190.56.205S126.055 10.694 79.799 56.95c-38.674 38.674-56.07 60.844-50.033 77.785"
            fill="#0072BC"
          />
          <path
            d="M151.2 11.755c1.245 6.565 4.475 12.94 9.67 18.138 5.198 5.199 11.576 8.427 18.142 9.674C187.817 16.993 190.56.206 190.56.206S173.774 2.948 151.2 11.755"
            fill="#FDCB0F"
          />
          <path
            d="M153.935 62.284c-7.03 7.03-18.426 7.03-25.455 0-7.03-7.028-7.03-18.424 0-25.452 7.029-7.03 18.426-7.03 25.455 0 7.029 7.028 7.029 18.424 0 25.452M123.804 79.428c-3.442 3.442-9.024 3.442-12.468 0a8.818 8.818 0 0 1 0-12.468c3.444-3.441 9.026-3.441 12.468 0a8.814 8.814 0 0 1 0 12.468M97.41 93.356a1.696 1.696 0 0 1 0 2.398l-37.764 37.763a1.698 1.698 0 0 1-2.4 0 1.698 1.698 0 0 1 0-2.4L95.01 93.357a1.697 1.697 0 0 1 2.4 0"
            fill="#F6F7F9"
          />
          <path
            d="M66.59 166.56a3.549 3.549 0 0 1-5.017 0l-37.369-37.368a3.549 3.549 0 0 1 0-5.017 3.549 3.549 0 0 1 5.016 0l37.37 37.37a3.549 3.549 0 0 1 0 5.016"
            fill="#2C2A2A"
          />
        </g>
      </svg>
    </svg>
  </div>
  <ng-content></ng-content>
</div>
